import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { ApiStatus } from '../../types/api/status'
import { unitMeasure, unitMeasureType } from '../../types/slices/unitMeasureType'

const initialState: unitMeasureType =
{
    status: ApiStatus.FETCHED,
    unitMeasure: [],
    unitMeasureSelected: {} as unitMeasure,
    errorMessage: undefined,
    action: ''
}

const unitMeasureSlice = createSlice({
    name: 'unitMeasureSlice',
    initialState,
    reducers: {
        onFetchUnitMeasure (state, { payload }: { payload: unitMeasure[]}) {
        state.status = ApiStatus.FETCHED
        state.unitMeasure = payload
        state.errorMessage = undefined
        },
        onSetSelectedUnitMeasure (state, { payload }: { payload: unitMeasure }) {
        state.unitMeasureSelected = payload
        },
        changeStatus (state, { payload }: { payload: ApiStatus}){
        state.status = payload
        },
        setAction (state, { payload }: { payload: string }) {
        state.action = payload
        },
    }
})

export const selectUnitMeasureState = (state: RootState) => state.unitMeasureSlice
export default unitMeasureSlice.reducer
export const {
    onFetchUnitMeasure,
    onSetSelectedUnitMeasure,
    changeStatus,
    setAction,
} = unitMeasureSlice.actions
